import classNames from 'classnames'
import { useField } from 'formik'
import { useRef } from 'react'

import type { ReactElement, InputHTMLAttributes } from 'react'

import VanillaTextInput from '~/components/Inputs/Basic/TextInput'
import InputControls from '~/components/Inputs/Formik/Controls'

import './styles.scss'

export interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  focus?: boolean
  name: string
  onDelete?: VoidFunction
}

const TextInput = ({ className, focus, name, onDelete, ...props }: Props): ReactElement => {
  const ref = useRef<HTMLInputElement>(null)

  const [field, { value }, { setValue }] = useField(name)

  return (
    <div className={classNames('page-container-text-input', className)}>
      <VanillaTextInput
        {...field}
        {...props}
        autoFocus={focus}
        className={classNames('page-container-text-input__input-wrapper', className)}
        ref={ref}
      />
      {value ? (
        <InputControls
          copyValue={value}
          onDelete={!props.disabled ? (onDelete ? onDelete : () => setValue('')) : undefined}
        />
      ) : null}
    </div>
  )
}

export default TextInput
